import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/img/icon/user-outline-grey.svg'
import _imports_1 from '@/assets/img/icon/steering-wheel-outline-grey.svg'
import _imports_2 from '@/assets/img/icon/calendar-outline-grey.svg'


const _hoisted_1 = {
  class: "content rounded-b-xl",
  style: {"padding":"20px 30px 20px 30px"}
}
const _hoisted_2 = {
  class: "flex w-full items-center justify-end",
  style: {"padding":"0px 5px 8px 5px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-extrabold text-30px" }, "Review Data Transaksi PP"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey font-normal text-xl" }, "Berikut adalah detail pendapatan dan pengeluaran per-RIT")
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-4 border-grey-3 rounded-xl" }
const _hoisted_6 = { class: "flex items-center gap-3" }
const _hoisted_7 = { class: "font-extrabold text-xl text-primary" }
const _hoisted_8 = { class: "text-grey text-base font-normal" }
const _hoisted_9 = { class: "flex items-center gap-3" }
const _hoisted_10 = { class: "flex items-center gap-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-14px h-14px shrink-0"
}, null, -1)
const _hoisted_12 = { class: "text-sm font-medium text-grey leading-none" }
const _hoisted_13 = { class: "flex items-center gap-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-14px h-14px shrink-0"
}, null, -1)
const _hoisted_15 = { class: "text-sm font-medium text-grey leading-none" }
const _hoisted_16 = { class: "flex items-center gap-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-14px h-14px shrink-0"
}, null, -1)
const _hoisted_18 = { class: "text-sm font-medium text-grey leading-none" }
const _hoisted_19 = { class: "grid grid-cols-1 md grid-cols-2 gap-5 mt-5" }
const _hoisted_20 = { class: "bg-neutral rounded-xl background-semiwhite-1 border-grey-2 w-full p-4 mb-5 md:mb-0" }
const _hoisted_21 = { class: "mb-4 border-bottom-grey-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-4 mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-semibold text-neutral-dark" }, "Pendapatan")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm font-semibold" }, "Pendapatan Tiket")
], -1)
const _hoisted_24 = { class: "px-3" }
const _hoisted_25 = { class: "w-full table-variant text-neutral500 px-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left w-2/5" }, "Dari - Ke"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left w-1/5" }, "Jumlah"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-right w-2/5" }, "Nominal")
  ])
], -1)
const _hoisted_27 = { class: "text-sm" }
const _hoisted_28 = { class: "w-2/5 pr-3" }
const _hoisted_29 = { class: "text-left w-1/5" }
const _hoisted_30 = { class: "text-right w-2/5 pl-3" }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "text-xs text-center"
}, "- Kosong -", -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm font-semibold" }, "Pendapatan Lain - Lain")
], -1)
const _hoisted_36 = { class: "px-3" }
const _hoisted_37 = { class: "w-full table-variant text-neutral500 px-3" }
const _hoisted_38 = { class: "text-sm" }
const _hoisted_39 = { class: "w-2/5 pr-3" }
const _hoisted_40 = { class: "text-left w-1/5" }
const _hoisted_41 = { class: "text-right w-2/5 pl-3" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "text-xs text-center"
}, "- Kosong -", -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "flex items-center justify-between" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "font-extrabold text-base text-neutral-dark" }, "Grand Total", -1)
const _hoisted_47 = { class: "font-extrabold text-base text-right text-neutral-dark" }
const _hoisted_48 = { class: "bg-neutral rounded-xl w-full p-4 background-semiwhite-1 border-grey-2" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-semibold text-neutral-dark" }, "Pengeluaran")
], -1)
const _hoisted_50 = { class: "px-3" }
const _hoisted_51 = { class: "w-full table-variant text-neutral500" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left" }, "Jenis Pengeluaran"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-right" }, "Nominal")
  ])
], -1)
const _hoisted_53 = {
  class: "text-sm",
  style: {"overflow-y":"auto","min-height":"100px","max-width":"500px"}
}
const _hoisted_54 = { class: "text-right" }
const _hoisted_55 = { class: "text-base" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", { class: "font-extrabold text-neutral-dark" }, "Grand Total", -1)
const _hoisted_57 = { class: "font-extrabold text-right text-neutral-dark" }
const _hoisted_58 = { class: "text-right mt-16px" }
const _hoisted_59 = { class: "flex items-center justify-end gap-3" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_61 = /*#__PURE__*/_createTextVNode("Tutup PP")
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-xs italic mt-3" }, "* Pastikan seluruh RIT telah ditutup dan semua data pendapatan serta pengeluaran sudah benar.", -1)

import apiUseCase from '@/usecase/apiUseCase'
import HjpTabView from '@/views/components/tab/HjpTabView.vue'
import moment from 'moment'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import { ref, computed, onMounted, getCurrentInstance } from 'vue'
import currencyNumberFormat from '@/utils/helpers/rupiahFormat'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'ClosePpDialog',
  props: {
  show: {
    type: Boolean,
    default: false
  },
  dataHeader: {
    default: null as any
  }
},
  emits: ["hideDialog", "reloadHeader"],
  setup(__props, { emit }: { emit: ({
  (e: 'hideDialog'): void
  (e: 'reloadHeader'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const routeEndpoint = '/transaction/v1/Rit'
const transactionPpEndpoint = '/transaction/v1/TransactionPp'
const transactionPpEndpoint2 = '/transaction/v2/TransactionPps'
const ritExpenseRevisionEndpoint = '/transaction/v1/RitExpenseRevision'


const showModal = computed(() => props.show)
const dataHeader = computed(() => props.dataHeader)
const app = getCurrentInstance()
const {
  $toast, $strInd
} = app!.appContext.config.globalProperties
const store = useStore()
const currentTabIndex = ref(0)
const currentTabId = ref(null) as any
const currentTabData = ref(null) as any
const ritList = ref([]) as any
const isLoadingRitDetail = ref(false)
const ritIncomeData = ref(null) as any
const ritExpenseData = ref(null) as any
const grandTotalIncome = ref(0)
const grandTotalExpense = ref(0)

const closeDialog = () => {
  emit('hideDialog')
}

const reloadHeader = () => {
  emit('reloadHeader')
}

const getRitData = async () => {
  await apiUseCase.get(`${routeEndpoint}/${currentTabId.value}`).then((response) => {
    const { result, error } = response
    if (!error) {
      currentTabData.value = result
    }
  })
}

const countIncomeTotal = () => {
  grandTotalIncome.value = 0
  if (ritIncomeData.value) {
    // eslint-disable-next-line array-callback-return
    ritIncomeData.value.TotalTicketGroupByOriginDestination.map((x: any) => {
      grandTotalIncome.value += x.TotalTicketAmount
    })
    // eslint-disable-next-line array-callback-return
    ritIncomeData.value.RitOtherRevenues.map((x: any) => {
      grandTotalIncome.value += x.Value
    })
  }
}

const getRitDeposit = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${transactionPpEndpoint}/Deposit-Rit/${currentTabId.value}`).then((response) => {
    const { result, error } = response
    if (!error) {
      ritIncomeData.value = result
    }
  })
  countIncomeTotal()
  store.dispatch('hideLoading')
}

// const countOutcomeTotal = () => {
//   grandTotalExpense.value = 0
//   if (ritExpenseData.value) {
//     // eslint-disable-next-line array-callback-return, no-unused-expressions
//     ritExpenseData.value?.RitExpenses.map((x: any) => {
//       grandTotalExpense.value += x.Nominal
//     })
//   }
// }

const getRitExpense = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${ritExpenseRevisionEndpoint}/Latest-Revision/${currentTabId.value}`).then((response) => {
    console.log('expense', response)
    const { result, error } = response
    if (!error) {
      ritExpenseData.value = result.Items
      grandTotalExpense.value = result.TotalRevisiAmount
    }
  })
  store.dispatch('hideLoading')
  // countOutcomeTotal()
}

const getRitDetail = async () => {
  await getRitData()
  await getRitDeposit()
  await getRitExpense()
}

const tabsChange = (val: any, index: any) => {
  console.log('asdada', [val, index])
  currentTabId.value = val
  currentTabIndex.value = index
  getRitDetail()
}

const initRitList = () => {
  ritList.value = []
  if (dataHeader.value.Rits.length > 0) {
    // eslint-disable-next-line no-unused-expressions, array-callback-return
    const ritListTemp = dataHeader.value.Rits.sort((a: any, b: any) => moment(a.EndDate).diff(moment(b.EndDate)))
    ritListTemp.forEach((item: any, i: number) => {
      if (i === 0) {
        currentTabId.value = item.Id
        currentTabIndex.value = 0
      }
      const temp = {
        title: `RIT ${i + 1}`,
        value: item.Id
      }
      ritList.value.push(temp)
    })
    getRitDetail()
    console.log('ritList', ritList.value)
  }
}

const onSubmit = async () => {
  store.dispatch('showLoading')
  await apiUseCase.put(`${transactionPpEndpoint2}/${dataHeader.value?.Id}/Closed`, null).then((response) => {
    const { error } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: 'Transaksi PP berhasil ditutup',
        group: 'bc',
        closable: false,
        life: 3000
      })
      reloadHeader()
      closeDialog()
    } else {
      $toast.add({
        severity: 'error',
        detail: 'Transaksi PP gagal ditutup. Periksa kembali data setiap Rit atau hubungi Admin.',
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

onMounted(() => {
  console.log('dataHeader', dataHeader.value)
  initRitList()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Dialog), {
      class: "",
      showHeader: false,
      visible: _unref(showModal),
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showModal) ? (showModal).value = $event : null)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '75vw' },
      modal: true,
      contentClass: "wrap-ctn-modal-default"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("i", {
                class: "pi pi-times cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDialog()))
              })
            ])
          ]),
          _hoisted_3,
          _createElementVNode("div", null, [
            _createVNode(HjpTabView, {
              onTabsChange: tabsChange,
              tabHeader: _unref(ritList),
              currActive: currentTabIndex.value
            }, null, 8, ["tabHeader", "currActive"]),
            (!isLoadingRitDetail.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(currentTabData)?.RouteName ?? '-'), 1),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(`${_unref(currentTabData)?.FirstTerminal ?? '-'} - ${_unref(currentTabData)?.LastTerminal ?? '-'}`), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(dataHeader)?.CondecturName ?? '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(currentTabData)?.DriverName ?? '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(moment)(_unref(currentTabData)?.StartDate).format('DD MMMM YYYY - HH:mm')), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("table", _hoisted_25, [
                              _hoisted_26,
                              _createElementVNode("tbody", _hoisted_27, [
                                (_unref(ritIncomeData)?.TotalTicketGroupByOriginDestination && _unref(ritIncomeData)?.TotalTicketGroupByOriginDestination.length > 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(ritIncomeData)?.TotalTicketGroupByOriginDestination, (dataProfit, key) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                        _createElementVNode("td", _hoisted_28, _toDisplayString(`${dataProfit.OriginTerminalCode ?? ''} -
                                                      ${dataProfit.DestinationTerminalCode ?? ''}`), 1),
                                        _createElementVNode("td", _hoisted_29, _toDisplayString(`${dataProfit.TotalTicketSold} Orang`), 1),
                                        _createElementVNode("td", _hoisted_30, _toDisplayString(_unref(currencyNumberFormat)(dataProfit.TotalTicketAmount)), 1)
                                      ]))
                                    }), 128))
                                  : (_openBlock(), _createElementBlock("tr", _hoisted_31, _hoisted_33))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("table", _hoisted_37, [
                              _createElementVNode("tbody", _hoisted_38, [
                                (_unref(ritIncomeData)?.RitOtherRevenues && _unref(ritIncomeData)?.RitOtherRevenues.length > 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(ritIncomeData)?.RitOtherRevenues, (dataProfit, key) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                        _createElementVNode("td", _hoisted_39, _toDisplayString(dataProfit.RevenueName ?? ''), 1),
                                        _createElementVNode("td", _hoisted_40, _toDisplayString(`${dataProfit.Quantity} Orang`), 1),
                                        _createElementVNode("td", _hoisted_41, _toDisplayString(_unref(currencyNumberFormat)(dataProfit.Value)), 1)
                                      ]))
                                    }), 128))
                                  : (_openBlock(), _createElementBlock("tr", _hoisted_42, _hoisted_44))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(currencyNumberFormat)(grandTotalIncome.value)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _hoisted_49,
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("table", _hoisted_51, [
                            _hoisted_52,
                            _createElementVNode("tbody", _hoisted_53, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ritExpenseData), (dataExpense, idx) => {
                                return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                  _createElementVNode("td", null, _toDisplayString(dataExpense.ExpenseName), 1),
                                  _createElementVNode("td", _hoisted_54, _toDisplayString(_unref(currencyNumberFormat)(dataExpense.RevisiAmount)), 1)
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("tfoot", _hoisted_55, [
                              _createElementVNode("tr", null, [
                                _hoisted_56,
                                _createElementVNode("td", _hoisted_57, _toDisplayString(_unref(currencyNumberFormat)(grandTotalExpense.value)), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_unref(Button), {
                        class: "btn-back",
                        onClick: closeDialog
                      }, {
                        default: _withCtx(() => [
                          _hoisted_60
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Button), {
                        class: "btn-primary text-white mr-3 px-10 py-1",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (onSubmit()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_61
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_62
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})